import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Checkbox } from 'ui-components/components/checkbox';

import messages from './messages';
import { emptyObject } from 'ui-components/default-props/empty';
import { SellerSettings } from '../../../../../enums/seller-settings/seller-settings';
import { useShipmentManifestItems } from '../../../../../hooks/use-seller-setting';
import sharedMessages from '../shared-messages';
import style from '../style.module.less';

const ShipmentManifestDocumentOptionsModal = ({ onInit, settingsState = emptyObject, onCheckboxChange }) => {
  const shipmentManifestItems = useShipmentManifestItems();
  const initialSettingsState = useMemo(
    () => ({
      [SellerSettings.shipmentManifestItems.key]: shipmentManifestItems,
    }),
    [shipmentManifestItems],
  );

  useEffect(() => {
    onInit(initialSettingsState);
  }, [onInit, initialSettingsState]);

  const listItemNames =
    settingsState[SellerSettings.shipmentManifestItems.key] ?? initialSettingsState[SellerSettings.shipmentManifestItems.key];
  return (
    <>
      <BannerMessageV2 content={<FormattedMessage {...sharedMessages.affectsAllUsersWarning} />} status={BannerStatus.Info} />
      <div className={style.description}>
        <FormattedMessage {...messages.shipmentManifestOptionsDescription} />
      </div>
      <div className={style['print-options-grid']}>
        <FormattedMessage {...messages.itemNamesLabel} />
        <div>
          <Checkbox
            checked={listItemNames}
            label={<FormattedMessage {...messages.itemNamesOption} />}
            name={SellerSettings.shipmentManifestItems.key}
            onChange={onCheckboxChange}
          />
        </div>
      </div>
    </>
  );
};

ShipmentManifestDocumentOptionsModal.propTypes = {
  onInit: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  settingsState: PropTypes.object,
};

export default ShipmentManifestDocumentOptionsModal;
